import { api } from './client';
import type { AdminUserWithPermissionsRow, SectionPermissionItem } from '../types/api';

export async function fetchNonSuperAdmins(): Promise<AdminUserWithPermissionsRow[]> {
  const { data } = await api.get<AdminUserWithPermissionsRow[]>('/admin/permissions/admins');
  return data;
}

export async function fetchUserPermissions(userId: string): Promise<SectionPermissionItem[]> {
  const { data } = await api.get<SectionPermissionItem[]>(`/admin/permissions/users/${userId}`);
  return data;
}

export async function updateUserPermissions(
  userId: string,
  permissions: SectionPermissionItem[],
): Promise<SectionPermissionItem[]> {
  const { data } = await api.put<SectionPermissionItem[]>(`/admin/permissions/users/${userId}`, {
    permissions,
  });
  return data;
}

export async function fetchMyPermissions(): Promise<SectionPermissionItem[]> {
  const { data } = await api.get<SectionPermissionItem[]>('/admin/permissions/me');
  return data;
}
